import { render } from "./Tips2.vue?vue&type=template&id=778ab693&scoped=true"
import script from "./Tips2.vue?vue&type=script&lang=js"
export * from "./Tips2.vue?vue&type=script&lang=js"

import "./Tips2.vue?vue&type=style&index=0&id=778ab693&scoped=true&lang=css"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778ab693"]])

export default __exports__